import { lazy } from 'react';

import withSuspense from '@/utils/ui/withSuspense';
import TrendingCarouselSkeleton from './TrendingCarouselSkeleton';

const TrendingCarousel = withSuspense(
  lazy(() => import('./TrendingCarousel')),
  TrendingCarouselSkeleton
);

export default TrendingCarousel;
